export default __webpack_public_path__ + "static/media/student_famale_with_bubble_chat.89b9d1f0.svg";